/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ReportUrl } from '../../models/report-url';

export interface ListReportUrls$Params {}

export function listReportUrls(
  http: HttpClient,
  rootUrl: string,
  params?: ListReportUrls$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<Array<ReportUrl>>> {
  const rb = new RequestBuilder(rootUrl, listReportUrls.PATH, 'get');
  if (params) {
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ReportUrl>>;
    })
  );
}

listReportUrls.PATH = '/admin/reporting/report-url';
